import { Button } from "react-bootstrap";
import TableContainer from "./TableContainer";
import { tableHeaders } from "../../hooks/constants";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { load_actives_list } from "../../actions/management_content";
import CreateActiveModal from "../Modals/CreateActiveModal";
import TransactionTable from "./TransactionTable";
import { hasPermission } from "../../hooks/userPermissions";

const FinanceTablesContainer = ({
  dateValues,
  activeType,
  transactionType = "",
}) => {
  // const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { title, optionName } = activeType;
  const [activesList, setActivesList] = useState([]);
  const [modalsData, setModalsData] = useState({
    activeModalId: null,
    activeModalShow: false,
    // subcategoryModalId: null,
    // subcategoryModalShow: false,
  });
  // const [subcategoryList, setSubcategoryList] = useState({
  //   service: [],
  //   product: [],
  //   rent: [],
  //   salary: [],
  //   bank: [],
  //   other: [],
  // });
  // const fetchSubcategories = async () => {
  //   const data = await load_subcategories_list();
  //   if (data) {
  //     const key = Object.keys(data);
  //     setSubcategoryList({ ...subcategoryList, [key]: data[key] });
  //   }
  // };

  const fetchActivesList = async () => {
    const data = await load_actives_list({
      active_type: optionName,
    });
    if (data) {
      const key = Object.keys(data);
      setActivesList(data[key]);
    }
  };

  const handleActiveEdit = (activeId) => {
    setModalsData({
      ...modalsData,
      activeModalId: activeId,
      activeModalShow: true,
    });
  };

  const refreshTable = (fetchFunction) => {
    fetchFunction();
  };

  const tableConfigActives = {
    headers: tableHeaders.activesTable,
    checkable: false,
    detailFunction: handleActiveEdit,
    listData: activesList,
    tableHeight: "table-height-5",
  };

  useEffect(() => {
    // dispatch(checkAuthenticated());

    fetchActivesList();
  }, [dateValues, optionName]);
  return (
    <div className="finance-tables-container py-2">
      <div className="row">
        <div className="category-list col-12">
          <div className="list-header d-flex justify-content-between align-items-center mb-2">
            <h4 className="m-0">Lista {activeType.title}</h4>
            <div className="d-flex gap-2 mx-2 h-50">
              <Button
                variant="outline-secondary"
                onClick={() => refreshTable(fetchActivesList)}
              >
                <i className="bi bi-arrow-clockwise" />
              </Button>
              {hasPermission(user, "create:active") && (
                <Button
                  variant="primary d-flex align-items-center gap-2"
                  onClick={() =>
                    setModalsData({
                      ...modalsData,
                      activeModalShow: true,
                    })
                  }
                >
                  Agregar
                  <i className="bi bi-plus-circle" />
                </Button>
              )}
            </div>
          </div>
          <TableContainer tableConfig={tableConfigActives} />
        </div>
      </div>
      <div className="transaction-list">
        <TransactionTable
          transactionType={transactionType}
          refreshTable={refreshTable}
          optionName={optionName}
          dateValues={dateValues}
          user={user}
        />
      </div>
      <CreateActiveModal
        show={modalsData.activeModalShow}
        onHide={() => {
          fetchActivesList();

          setModalsData({
            ...modalsData,
            activeModalId: null,
            activeModalShow: false,
          });
        }}
        activeId={modalsData.activeModalId}
        activeType={{ title, optionName }}
        user={user}
        // subcategoryList={subcategoryList}
      />
      {/* <CreateSubcategoryModal
        show={modalsData.subcategoryModalShow}
        onHide={() => {
          fetchSubcategories();

          setModalsData({
            ...modalsData,
            subcategoryModalId: null,
            subcategoryModalShow: false,
          });
        }}
        subcategoryId={modalsData.subcategoryModalId}
        activeType={{ title, optionName }}
      /> */}
    </div>
  );
};

export default FinanceTablesContainer;
